// extracted by mini-css-extract-plugin
export default {"backdrop":"ModalSkeleton_backdrop__tr4+h","modal-wrapper":"ModalSkeleton_modal-wrapper__iMRZs"};